module.exports = {"610582001":"太华路街道","610582002":"岳庙街道","610582100":"孟塬镇","610582103":"华西镇","610582104":"罗敷镇","610582105":"华山镇","610582400":"国营陕西华山企业公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610582.json
// module id = 2623
// module chunks = 0